/**
 * Tarayıcı uyumlu değerlendirme token üretici.
 * Süre (TTL) yok. Yönetici tokenı kararla tek kullanımlık.
 * Lider/yönetici takip erişimi: odulOneriTrackingSession (magic link).
 */
const toHex = (buffer) =>
  Array.from(buffer)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')

export const createEvaluationToken = ({
  recordNumber,
  assigneeId,
  role,
}) => {
  if (!recordNumber || !assigneeId || !role) {
    throw new Error('recordNumber, assigneeId ve role zorunludur.')
  }

  const randomBytes = new Uint8Array(32)
  window.crypto.getRandomValues(randomBytes)

  const createdAtDate = new Date()

  return {
    tokenId: toHex(randomBytes),
    recordNumber,
    assigneeId,
    role,
    createdAt: createdAtDate.toISOString(),
    expiresAt: null,
  }
}

/** Takvim TTL yok — geçersizlik rol/süreç kurallarıyla yönetilir. */
export const isTokenExpired = () => false

export const DEFAULT_TTL_HOURS_EXPORT = null
